// src/i18nOptions.ts
import type { InitOptions } from 'i18next';

const isDevelopment = import.meta.env.MODE === 'development';

export const i18nOptions: InitOptions = {
  fallbackLng: 'en',
  // Map region codes from the browser ("de-DE", "de-AT", "en-US") to the plain
  // language. Many components check i18n.language === 'de' to pick the German
  // date format; without this a browser that reports "de-DE" shows German
  // texts but US dates.
  supportedLngs: ['de', 'en'],
  debug: isDevelopment,

  // Namespaces
  ns: ['common'],
  defaultNS: 'common',

  interpolation: {
    escapeValue: false, // not needed for React
  },

  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },

  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
};
